/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class t{constructor(){this._inputs=new Map}set(t,s){this._inputs.set(t,s)}get(t){return this._inputs.get(t)}has(t){return this._inputs.has(t)}release(t){this._inputs.get(t)?.release()&&this._inputs.delete(t)}}export{t as RenderPluginInput};
